function loop(theme, res, list, type) {
  const suffixes = { main: '', light: 'Light' };
  const suffixe = suffixes[type];
  // const contrast = 'contrastText';
  list.forEach(key => {
    res[`${key}${suffixe}`] = {
      color: theme.palette[key][type],
      '& svg .icon-fill': {
        fill: theme.palette[key][type],
      },
      '& svg .icon-stroke': {
        stroke: theme.palette[key][type],
      },
      '&:hover': {
        textDecorationLine: 'underline',
      },
    };
  });
}

export default theme => {
  const mains = ['white', 'black', 'grey', 'red', 'green', 'blue', 'orange', 'purple', 'teal'];
  const light = ['grey', 'green', 'blue', 'orange', 'purple', 'teal'];

  const res = {
    button: {
      '&.iconCenter': {
        alignItems: 'center',
      },
      '&.iconTop': {
        alignItems: 'flex-start',
      },
      '&.iconAbove': {
        alignItems: 'flex-start',
        '& > span': {
          flexDirection: 'column',
          '& > span': {
            marginBottom: theme.spacing(1),
          },
        },
      },
    },
    label: {
      width: '100%',
      textAlign: 'left',
    },
  };

  loop(theme, res, mains, 'main');
  loop(theme, res, light, 'light');

  return res;
};
